import { useEffect, useState } from 'react';
import { animate } from 'motion/react';
import { easings, useReducedMotion } from '@redpandev/ui';

export type CountUpProps = {
  /** Valeur finale (entière). */
  value: number;
  /** Durée de l'animation en secondes (défaut .9). */
  duration?: number;
  /** Formatage de la valeur affichée (ex : `(n) => n + ' %'`). */
  format?: (n: number) => string;
  className?: string;
};

/**
 * Gros chiffre en « count-up » animé (0 → valeur, ease fun).
 * `prefers-reduced-motion` → la valeur finale s'affiche instantanément.
 * La valeur affichée reste purement visuelle : le parent porte le label
 * accessible complet (voir StatsBlock) pour ne pas faire lire les étapes
 * intermédiaires au lecteur d'écran.
 */
export function CountUp({
  value,
  duration = 0.9,
  format = (n) => String(n),
  className,
}: CountUpProps) {
  const reduced = useReducedMotion();
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (reduced) return; // valeur affichée directement (dérivée au rendu)
    const controls = animate(0, value, {
      duration,
      ease: easings.fun,
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [value, duration, reduced]);

  return <span className={className}>{format(reduced ? value : display)}</span>;
}
